'use strict';

function isSameArray(a, b) {
  if (a.length !== b.length) return false;
  const set = new Set(b);
  return a.every(v => set.has(v));                                            
}


/* exported
  menuOperatorMappingGapsCtrl
 */
function menuOperatorMappingGapsCtrl($scope, $rootScope, Restangular, countries) {
  $scope.filters = { filteredCountries: [], selectedCountries: [] };

  $scope.countries = countries.map(function (country) {
    return country.name.common;
  }).sort();

  $scope.clearCountry = function clearCountry() {
    $scope.filters.selectedCountries = [];
  };

  $scope.search = function () {
    if ($scope.filters.selectedCountries.legth > 0 && isSameArray($scope.filters.selectedCountries, $scope.filters.filteredCountries)) {
      return;
    }
    const queryParams = $scope.filters.selectedCountries.length > 0 ? { countries: $scope.filters.selectedCountries.join(",") } : {};
    Restangular.all('v1/operator-mapping/list').getList(queryParams)
      .then(function (response) {
        $rootScope.$broadcast('operatorMappingGaps.list', response.plain ? response.plain() : response);
        $scope.filters.filteredCountries = $scope.filters.selectedCountries.slice();
      })
      .catch(function (err) {
        $rootScope.$emit('notify', {
          type: 'error',
          title: 'Failed to fetch',
          message: (err && err.data && err.data.message) || 'Failed to load operator mapping gaps',
        });
      });
  };
}

'use strict';

/* exported
  operatorMappingGapsCtrl
 */
function operatorMappingGapsCtrl($scope) {
  $scope.operatorMappingGaps = { list: [], filteredList: [] };
  $scope.searchTriggered = false;
  $scope.sort = { by: 'gmv_12go' };
  $scope.filters = { display: 'all', operator: null, performance: 'performance_all', operators: [] };
  $scope.displayedOperators = [];

  function sortBy12goBookings() {
    $scope.operatorMappingGaps.filteredList.sort((operator1, operator2) => operator2.total_tickets_12go - operator1.total_tickets_12go);
  };

  function sortByBookawayBookings() {
    $scope.operatorMappingGaps.filteredList.sort((operator1, operator2) => {
        const bookawayBookings1 = (operator1.mappedBookawayOperators || []).reduce((acc, bookawayOperator) => acc + (bookawayOperator.bookings_cnt || 0), 0);
        const bookawayBookings2 = (operator2.mappedBookawayOperators || []).reduce((acc, bookawayOperator) => acc + (bookawayOperator.bookings_cnt || 0), 0);
        return bookawayBookings2 - bookawayBookings1;
  });
  };

  function sortBy12goGmv() {
    $scope.operatorMappingGaps.filteredList.sort((operator1, operator2) => operator2.gmv - operator1.gmv);
  };

  $scope.applySort = function () {
    switch ($scope.sort.by) {
      case 'total_tickets_12go':
        sortBy12goBookings();
        break;
      case 'bookaway_bookings':
        sortByBookawayBookings();
        break;
      case 'gmv_12go':
        sortBy12goGmv();
        break;
    }
  };

  function filterPerformance(results) {
    if ($scope.filters.performance === 'performance_all') {
      return results;
    }
    results.sort((operator1, operator2) => operator2.gmv - operator1.gmv);
    if ($scope.filters.performance === 'performance_10') {
      return results.slice(0, Math.floor($scope.operatorMappingGaps.list.length * 0.1));
    } else {
      return results.slice(0, Math.floor($scope.operatorMappingGaps.list.length * 0.25));
    }
  };

  function filterMapped(results) {
    if ($scope.filters.display === 'mapped') {
      return results.filter(operator => (operator.mappedBookawayOperators || []).length > 0);
    } else if ($scope.filters.display === 'not_mapped') {
      return results.filter(operator => (operator.mappedBookawayOperators || []).length === 0);
    } else if ($scope.filters.display === 'mapped_explicit_by_id') {
      return results.filter(operator => (operator.mappedBookawayOperators || []).length > 0 && operator.matchType === 'explicit_by_id');
    } else if ($scope.filters.display === 'mapped_exact_match') {
      return results.filter(operator => (operator.mappedBookawayOperators || []).length > 0 && operator.matchType === 'exact_match');
    } else if ($scope.filters.display === 'mapped_fuzzy_match') {
      return results.filter(operator => (operator.mappedBookawayOperators || []).length > 0 && operator.matchType === 'fuzzy_match');
    } else {
      return results;
    }
  }

  function filterOperator(results) {
    if ($scope.filters.operators.length > 0) {
      return results.filter(operator => $scope.filters.operators.includes(operator.operator_name));
    } else {
      return results;
    }
  }

  $scope.getMatchTypeLabel = function (matchType) {
    switch (matchType) {
      case 'explicit_by_id':
        return 'Explicit by ID';
      case 'exact_match':
        return 'Exact match';
      case 'fuzzy_match':
        return 'Fuzzy match';
      default:
        return "";
    }
  };

  $scope.applyFilters = function () {
    let results = $scope.operatorMappingGaps.list.slice();
    results = filterMapped(results);
    results = filterOperator(results);
    results = filterPerformance(results);
    $scope.operatorMappingGaps.filteredList = results;
    $scope.applySort();
  };

  $scope.$on('operatorMappingGaps.list', function (event, list) {
    $scope.operatorMappingGaps.list = list || [];
    $scope.searchTriggered = true;
    $scope.displayedOperators = Array.from(new Set(
      $scope.operatorMappingGaps.list.map(operator => operator.operator_name)
    )).sort((a, b) => a.localeCompare(b));
    $scope.applyFilters();
  });
}
